if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        TextControl,
    } = window.wp.components;

    registerBlockType('custom-gutenberg/button', {
        // built-in attributes
        title: 'Cta button',
        description: 'Cta button',
        icon: '',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            text: {
                type: 'string',
                default: 'Istražite krstarenja'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                link,
                text,
            } = attributes;

            // custom functions
            function onLinkChange (link) {
                setAttributes({link: link});
            };


            function onTextChange(text) {
                setAttributes({text: text});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <p><strong>Enter url: (ex: /putovanja)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                        <br />
                        <p><strong>Text</strong></p>
                        <TextControl value={ text } onChange={ onTextChange }></TextControl>
                    </PanelBody>
                </InspectorControls>
                ,
                <a class="cta-btn" style= {{ 
                    background: '#B39A84',
                    padding: '10px 30px',
                    color: 'white'
                    }}>
                    <RichText 
                        key="editable" 
                        tagName="span"
                        placeholder="Istražite krstarenja" 
                        value={ text }
                        onChange={ onTextChange } />
                </a>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                text,
            } = attributes;

            return (
                <a className="cta-btn" href={ link }>
                    <div className="cta-btn-content">
                        <div className="text">
                            { text }
                        </div>
                    </div>
                </a>
            );
        },
    });
}